import React from 'react';
import { Grid, Stack, Typography } from '@mui/material';
import { baseColors } from '../../../Themes/colors';
var ApplicationMetrics = function (_a) {
    var metrics = _a.metrics;
    return (React.createElement(Grid, { container: true, spacing: 0.75, sx: { width: 'auto', flexWrap: 'nowrap', alignItems: 'center' } }, metrics.map(function (metric, index) {
        var isCurrencyMetric = metric.label === '$';
        var valueNode = (React.createElement(Typography, { sx: {
                fontSize: 15,
                lineHeight: '18px',
                fontWeight: 700,
                color: baseColors.fullBlack,
            } }, metric.value));
        var labelNode = (React.createElement(Typography, { component: "span", sx: {
                fontSize: isCurrencyMetric ? 15 : 12,
                lineHeight: '16px',
                fontWeight: 500,
                color: baseColors.fullBlack,
            } }, metric.label));
        return (React.createElement(Grid, { item: true, key: index },
            React.createElement(Stack, { direction: "row", alignItems: "baseline", spacing: 0.3, sx: {
                    px: 1.2,
                    py: 0.8,
                    backgroundColor: baseColors.greyPreset[55],
                    borderRadius: 1,
                    border: "1px solid ".concat(baseColors.greyPreset[40]),
                } }, isCurrencyMetric ? (React.createElement(React.Fragment, null,
                labelNode,
                valueNode)) : (React.createElement(React.Fragment, null,
                valueNode,
                metric.suffix && (React.createElement("span", { className: "icon-doller", style: { fontSize: isCurrencyMetric ? 15 : 12 } })),
                labelNode)))));
    })));
};
export default ApplicationMetrics;
